import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-interaction-search-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfInteractionSearchIconProps extends SvgIconProps {
  fillColor: any;
}

/**
 * Component displays Instagram Icon
 * @param props -CcfInstaIconProps
 * @returns instagram svg icon
 * @example <CcfInstIcon/>
 */
export function CcfInteractionSearchIcon(props: CcfInteractionSearchIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="-2 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 8.94883C2 12.4688 4.88 15.3488 8.4 15.3488C9.84 15.3488 11.2 14.8688 12.32 13.9888L16.64 18.3088C16.96 18.6288 17.44 18.6288 17.76 18.3088C18.08 17.9888 18.08 17.5088 17.76 17.1888L13.44 12.8688C14.32 11.7488 14.8 10.3888 14.8 8.94883C14.8 5.42883 11.92 2.54883 8.4 2.54883C4.88 2.54883 2 5.42883 2 8.94883ZM3.6 8.94883C3.6 6.30883 5.76 4.14883 8.4 4.14883C11.04 4.14883 13.2 6.30883 13.2 8.94883C13.2 11.5888 11.04 13.7488 8.4 13.7488C5.76 13.7488 3.6 11.5888 3.6 8.94883Z"
          fill={props?.fillColor ? props?.fillColor : '#2D5651'}
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfInteractionSearchIcon;
